<template>
  <div class="relative">
    <table class="w-full" style="min-width: 1000px;">
      <thead class="sticky top-0 bg-white z-10">
        <slot name="head"></slot>
      </thead>
      <tbody>
        <slot name="body"></slot>
      </tbody>
    </table>
  </div>
</template>

<script>
export default {
  name: 'DataTable',
  props: {

  }
}
</script>
